import React from 'react'
import { Link ,useParams } from 'react-router-dom'
import { Carousel } from 'react-bootstrap'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { injectIntl, defineMessages } from 'react-intl'

import MiniBrowse from '../../browse/containers/MiniBrowse'
import UpComingRecipes from '../../menu/components/UpComingRecipes'
import Menu from '../../menu/containers/Menu'
import documentTitle from '../../common/documentTitle'
// import * as NewsActions from "../actions/NewsActions";

require("./../css/book.scss");
//require("https://pro.fontawesome.com/releases/v5.10.0/css/all.css");


class Book extends React.Component {
  componentDidMount() {
    if (!this.props.news.news) {
      //this.props.newsActions.load();
    }
  }

  componentWillUnmount() {
    documentTitle();
  }

  render() {
    const {formatMessage} = this.props.intl;
    const messages = defineMessages({
      browseRecipeButton: {
        id: 'news.browse_recipe_button',
        description: 'Browse All Recipes',
        defaultMessage: 'Browse All Recipes',
      },
    });
    
    documentTitle("Download Book");


    return (
      <div className="app">
      <PdfFrame />
    </div>
    );
  }
}

class PdfFrame extends React.Component {
  state = {
    pdfIsLoading: true,
  }
  componentDidMount() {
    this.pdfFrame.addEventListener("load", this.handleIframeLoad); 
  }
  componentWillUnmount() {
    this.pdfFrame.removeEventListener("load", this.handleIframeLoad)
  }
  handleIframeLoad = (event) => {
    console.log('Iframe content has been loaded :)')
    this.setState({
      pdfIsLoading: false
    })
  }
  
  render() {
    //let {type} = useParams();
    return(
        <div className="pdfFrame">
          {this.state.pdfIsLoading ? <Loader /> : null}
          <iframe 
            width="100%" 
            height="100%" 
            src="/api/v1/pdf/full"
            frameBorder="0" 
            allow="autoplay; encrypted-media" 
            allowFullScreen="false" 
            ref={ frame => this.pdfFrame = frame }
            className="pdfFrame__iframe"
          />
          
        </div>
    );
  }  
}

const Loader = () => {
return(
  <div className="loader">
    <br></br>
    <br></br> 
    <br></br>
    <br></br> 
    Generating PDF for you.
    <br></br> 
    <div className="spinner">
      <i className="fa fa-utensils faa-tada animated" />
    </div>
  </div>
);
}

const mapStateToProps = state => ({
  news: state.news,
  user: state.user,
});

const mapDispatchToProps = dispatch => ({
  //newsActions: bindActionCreators(NewsActions, dispatch),
});

export default injectIntl(connect(
  mapStateToProps,
  mapDispatchToProps
)(Book));



// WEBPACK FOOTER //
// ./modules/book/components/full.js